// extracted by mini-css-extract-plugin
export var actionButton = "_l0-t";
export var buttonContainer = "_l0-0";
export var buttonContainer2 = "_l0-1";
export var buttonSection = "_l0-2";
export var details = "_l0-3";
export var dropdownItem = "_l0-5";
export var dropdownItemsContainer = "_l0-4";
export var fileInput = "_l0-r";
export var headerButton = "_l0-6";
export var icon = "_l0-7";
export var input = "_l0-8";
export var macroListItem = "_l0-9";
export var mainContent = "_l0-a";
export var microText = "_l0-b";
export var modal = "_l0-w";
export var optionsButton = "_l0-c";
export var paperclip = "_l0-s";
export var pillContent = "_l0-d";
export var preview = "_l0-e";
export var preview2 = "_l0-f";
export var quillEditor = "_l0-q";
export var selectedMacro = "_l0-g";
export var sidebar = "_l0-h";
export var sidebarHeader = "_l0-j";
export var sidebarList = "_l0-i";
export var sidebarListItem = "_l0-k";
export var sidebarSearch = "_l0-l";
export var snoozeDurationWrapper = "_l0-v";
export var statusPillContainer = "_l0-m";
export var tagsContainer = "_l0-n";
export var unselectedMacro = "_l0-o";
export var variable = "_l0-u";
export var wrapper = "_l0-p";